import BaseHttpService from './base-http.service'

const apiClient = BaseHttpService();

const getUser = async (id: number) => {
          return await apiClient.getUserById("/user", id);
}

const loginUser = async (username: string, password: string) => {
          return await apiClient.loginUser("/auth/login", username, password);
}

const userServices = {
          getUser,
          loginUser
}
export default userServices;